<template>
  <SharedLink
    v-if="link"
    :link="link"
  >
    <NuxtImg
      v-if="img"
      class="max-w-[100px]"
      :src="img.src"
      sizes="lg:100vw 48vw"
      :srcset="img.srcset"
      :title="img.title"
      :alt="img.alt"
      loading="lazy"
    />
  </SharedLink>
</template>

<script lang="ts" setup>
interface Props {
  link?: any;
  img?: any;
}

withDefaults(defineProps<Props>(), {
  link: undefined,
  img: undefined,
});
</script>
